import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.state';
import * as fromDiaryNotesData from './diary-notes.reducer';
import * as fromMedicationData from './medication.reducer';
import * as fromUserData from './user.reducer';
import * as fromPrescriptionsData from './prescriptions.reducer';
import * as fromDeliveredMedicationsData from './delivered-medications.reducer';

export const appReducer: ActionReducerMap<AppState> = {
  userData: fromUserData.userReducer,
  medicationData: fromMedicationData.medicationReducer,
  diaryNotesData: fromDiaryNotesData.diaryNotesReducer,
  prescriptionsData: fromPrescriptionsData.prescriptionsReducer,
  deliveredMedicationsData: fromDeliveredMedicationsData.deliveredMedicationReducer,
};
